import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { GOOGLE_MAPS_API_KEY } from '@/config/constants';
const IMAGE_SIZE = 180;
const BUILDING_ZOOM = 19;
type SatelliteImageProps = {
  latitude?: number;
  longitude?: number;
};
const SatelliteImage = t0 => {
  const $ = _c(8);
  const {
    latitude,
    longitude
  } = t0;
  const [isError, setIsError] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const isCoordinatesAvailable = Boolean(latitude && longitude);
  let t1;
  let t2;
  if ($[0] !== isCoordinatesAvailable || $[1] !== latitude || $[2] !== longitude) {
    t1 = () => {
      if (isCoordinatesAvailable) {
        const url = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${BUILDING_ZOOM}&size=${IMAGE_SIZE}x${IMAGE_SIZE}&maptype=satellite&key=${GOOGLE_MAPS_API_KEY}`;
        setImageUrl(url);
      }
    };
    t2 = [latitude, longitude, isCoordinatesAvailable];
    $[0] = isCoordinatesAvailable;
    $[1] = latitude;
    $[2] = longitude;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isCoordinatesAvailable || !imageUrl || isError) {
    return null;
  }
  let t3;
  if ($[5] !== imageUrl || $[6] !== isError) {
    t3 = <div className="absolute z-50 overflow-hidden text-center border border-solid rounded top-2 right-2 border-tertiary backdrop-blur-sm size-24 md:size-[180px]">{isError ? <div className="flex items-center justify-center w-full h-full"><p className="text-body-2 text-tertiary">No satellite image available</p></div> : <img alt="Satellite view" src={imageUrl} className="object-cover w-full h-full" onError={() => setIsError(true)} referrerPolicy="no-referrer" />}</div>;
    $[5] = imageUrl;
    $[6] = isError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default SatelliteImage;